import Box from "@mui/material/Box";
import Slider from "@mui/material/Slider";
import Typography from "@mui/material/Typography";
import * as React from "react";

function valuetext(value: number) {
  return String(value);
}

type CustomSliderProps = {
  setClusterValue: React.Dispatch<React.SetStateAction<number>>;
  clusterValue: number;
  onInteractionStart?: () => void;
};

export default function CustomSlider({
  setClusterValue,
  clusterValue,
  onInteractionStart,
}: CustomSliderProps) {

  const interactionStartedRef = React.useRef(false);

  // ClusterChirp uses the opposite direction internally:
  // slider left = coarse, slider right = fine
  const sliderValue = 12 - clusterValue;

  const handleSliderChange = (
    _event: Event,
    newValue: number | number[]
  ) => {
    if (!interactionStartedRef.current) {
      onInteractionStart?.();
      interactionStartedRef.current = true;
    }

    setClusterValue(12 - (newValue as number));
  };

  const handleSliderCommitted = () => {
    interactionStartedRef.current = false;
  };

  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "stretch",
        boxSizing: "border-box",
        px: "8px",
      }}
    >
      <Slider
        orientation="horizontal"
        value={sliderValue}
        onChange={handleSliderChange}
        onChangeCommitted={handleSliderCommitted}
        getAriaValueText={valuetext}
        marks={[]}
        min={1}
        max={11}
        step={1}
        valueLabelDisplay="off"
        sx={{
          width: "100%",
          padding: "12px 0 5px 0",

          "& .MuiSlider-rail": {
            width: "100%",
            height: "10px",
            borderRadius: "4px",
            background: "#D3D3D3",
            opacity: 1,
            clipPath:
              "polygon(0% 0%, 0% 100%, 100% 50%, 0% 0%)",
          },

          "& .MuiSlider-track": {
            display: "none",
          },

          "& .MuiSlider-thumb": {
            width: "18px",
            height: "18px",
            borderRadius: "50%",
            backgroundColor: "#1e90ff",
            border: "4px solid #fff",
            boxShadow:
              "0px 3px 1px -2px rgba(0,0,0,0.1), 0px 2px 2px 0px rgba(0,0,0,0.1), 0px 1px 5px 0px rgba(0,0,0,0.1)",
          },

          "& .MuiSlider-thumb:hover": {
            boxShadow:
              "0px 3px 1px -2px rgba(0,0,0,0.3), 0px 2px 2px 0px rgba(0,0,0,0.3), 0px 1px 5px 0px rgba(0,0,0,0.3)",
          },

          "& .MuiSlider-thumb.Mui-focusVisible": {
            boxShadow:
              "0px 3px 5px 1px rgba(0,0,0,0.3), 0px 1px 10px 2px rgba(0,0,0,0.3), 0px 2px 4px -1px rgba(0,0,0,0.3)",
          },

          "& .MuiSlider-thumb.Mui-active": {
            boxShadow:
              "0px 3px 5px 1px rgba(0,0,0,0.5), 0px 1px 10px 2px rgba(0,0,0,0.5), 0px 2px 4px -1px rgba(0,0,0,0.5)",
          },
        }}
      />

      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          width: "100%",
          marginTop: "-2px",
        }}
      >
        <Typography
          sx={{
            fontSize: "11px",
            fontWeight: "bold",
            color: "#555",
          }}
        >
          Coarse
        </Typography>

        <Typography
          sx={{
            fontSize: "11px",
            fontWeight: "bold",
            color: "#555",
          }}
        >
          Fine
        </Typography>
      </Box>
    </Box>
  );
}